// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__O1enl","modal":"Modal_modal__Q1MbB","close":"Modal_close__oSy0F","rotate":"Modal_rotate__ZgkLU"};